module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-med.fe5f3d48.jpg";